import { useDispatch } from "react-redux";
import Content from "@src/components/common/Content";
import { selectFolders, toggleAddEditFolder } from "@src/store/slices/menu";
import { useSelector } from "@src/store";
import {
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconCornerDownRight } from "@tabler/icons";
import { useState } from "react";
import AddEditFolderModal from "@src/components/modal/AddEditFolderModal";
import DeleteFolderModal from "@src/components/modal/DeleteFolderModal";

const Folders = () => {
  const dispatch = useDispatch();
  const folders = useSelector((state) => selectFolders(state));

  const onClickAdd = () => {
    dispatch(toggleAddEditFolder(true));
  };

  return (
    <Content
      heading="Folders"
      addHeading="Add Folder"
      onClickAdd={onClickAdd}
      hasSearch={false}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell key="col-1">Title</TableCell>
              <TableCell key="col-2" align="center" sx={{ pr: 3 }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {folders.map((folder) => {
              const optionsArray = [...folder.children];
              optionsArray.unshift(folder);

              return optionsArray.map((folder) =>
                "parentId" in folder && folder.parentId !== null ? (
                  <FolderRow key={folder.id} folder={folder} isChild />
                ) : (
                  <FolderRow key={folder.id} folder={folder} />
                )
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Content>
  );
};

export default Folders;

const FolderRow = ({ folder, isChild = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDeleteVisible, setIsDeleteVisible] = useState(false);

  const onClickEdit = () => {
    setIsVisible(true);
  };

  const onClickDelete = () => {
    setIsDeleteVisible(true);
  };

  return (
    <>
      <TableRow hover>
        <TableCell>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
            }}
          >
            {isChild && <IconCornerDownRight opacity={0.5} />}
            <Typography align="left" variant="subtitle1" component="p">
              {folder.title}
            </Typography>
          </div>
        </TableCell>
        <TableCell align="center" sx={{ pr: 3 }}>
          <Stack direction="row" justifyContent="center" alignItems="center">
            <Tooltip placement="top" title="Edit">
              <IconButton
                style={{ color: "green" }}
                aria-label="delete"
                size="large"
                onClick={onClickEdit}
              >
                <EditIcon sx={{ fontSize: "1.1rem" }} />
              </IconButton>
            </Tooltip>
            <Tooltip placement="top" title="Delete">
              <IconButton
                style={{ color: "red" }}
                aria-label="delete"
                size="large"
                onClick={onClickDelete}
              >
                <DeleteIcon sx={{ fontSize: "1.1rem" }} />
              </IconButton>
            </Tooltip>
          </Stack>
        </TableCell>
      </TableRow>

      <AddEditFolderModal
        isVisible={isVisible}
        onDismiss={() => setIsVisible(false)}
        selectedFolder={folder.id}
        isChildFolder={isChild}
      />

      <DeleteFolderModal
        isVisible={isDeleteVisible}
        onDismiss={() => setIsDeleteVisible(false)}
        selectedFolder={folder.id}
        isChildFolder={isChild}
      />
    </>
  );
};
